import React from "react";
import { Switch, View, Text, StyleSheet } from "react-native";
import { useTheme } from "../theme";

interface LhToggleSwitchProps {
  value: boolean;
  onValueChange: (value: boolean) => void;
  label?: string;
  disabled?: boolean;
}

const LhToggleSwitch: React.FC<LhToggleSwitchProps> = ({
  value,
  onValueChange,
  label,
  disabled = false,
}) => {
  const { colors } = useTheme();
  return (
    <View style={styles.container}>
      {label && <Text style={[styles.label, { color: colors.text.primary }]}>{label}</Text>}
      <Switch
        value={value}
        onValueChange={onValueChange}
        trackColor={{ false: colors.border.default, true: colors.brand.primary }}
        thumbColor={value ? colors.brand.primary : colors.background.surface}
        disabled={disabled}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  label: {
    marginRight: 8,
    fontSize: 14,
  },
});

export default LhToggleSwitch;
